import React from 'react';
import { SOCIAL } from './nav';

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
    <path fill="currentColor" d="M12 2.2c3.2 0 3.6 0 4.9.1 1.2.1 1.9.2 2.3.4.6.2 1 .5 1.5 1 .4.4.7.9 1 1.5.2.4.4 1.1.4 2.3.1 1.3.1 1.7.1 4.9s0 3.6-.1 4.9c-.1 1.2-.2 1.9-.4 2.3-.2.6-.5 1-1 1.5-.4.4-.9.7-1.5 1-.4.2-1.1.4-2.3.4-1.3.1-1.7.1-4.9.1s-3.6 0-4.9-.1c-1.2-.1-1.9-.2-2.3-.4-.6-.2-1-.5-1.5-1-.4-.4-.7-.9-1-1.5-.2-.4-.4-1.1-.4-2.3C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.9c.1-1.2.2-1.9.4-2.3.2-.6.5-1 1-1.5.4-.4.9-.7 1.5-1 .4-.2 1.1-.4 2.3-.4C8.4 2.2 8.8 2.2 12 2.2m0-2.2C8.7 0 8.3 0 7 0 5.7.1 4.8.3 4 0.6c-.9.3-1.6.7-2.3 1.4C1 2.7.6 3.4.3 4.2.1 5 0 5.9 0 7.2 0 8.5 0 8.9 0 12s0 3.5.1 4.8c.1 1.3.3 2.2.6 3 .3.9.7 1.6 1.4 2.3.7.7 1.4 1.1 2.3 1.4.8.3 1.7.5 3 .6C8.3 24 8.7 24 12 24s3.5 0 4.8-.1c1.3-.1 2.2-.3 3-.6.9-.3 1.6-.7 2.3-1.4.7-.7 1.1-1.4 1.4-2.3.3-.8.5-1.7.6-3 .1-1.3.1-1.7.1-4.8s0-3.5-.1-4.8c-.1-1.3-.3-2.2-.6-3-.3-.9-.7-1.6-1.4-2.3C21.3 1.3 20.6.9 19.8.6 19 .3 18.1.1 16.8 0 15.5 0 15.1 0 12 0z" />
    <path fill="currentColor" d="M12 5.8A6.2 6.2 0 1 0 12 18.2 6.2 6.2 0 1 0 12 5.8zm0 10.2A4 4 0 1 1 12 8a4 4 0 0 1 0 8zm6.4-10.9a1.4 1.4 0 1 1-2.9 0 1.4 1.4 0 0 1 2.9 0z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
    <path fill="currentColor" d="M20.5 2h-17A1.5 1.5 0 0 0 2 3.5v17A1.5 1.5 0 0 0 3.5 22h17a1.5 1.5 0 0 0 1.5-1.5v-17A1.5 1.5 0 0 0 20.5 2zM8 19H5v-9h3zM6.5 8.3A1.7 1.7 0 1 1 6.5 4.9a1.7 1.7 0 0 1 0 3.4zM19 19h-3v-4.7c0-1.4-.5-2.4-1.8-2.4-1 0-1.5.7-1.8 1.3-.1.2-.1.5-.1.8V19h-3s.1-8.4 0-9h3v1.4c.4-.6 1.2-1.6 3-1.6 2.2 0 3.7 1.4 3.7 4.4z" />
  </svg>
);

const SocialIcons = ({ className = 'gf-social' }) => {
  const links = [
    SOCIAL.instagramUrl && { href: SOCIAL.instagramUrl, label: 'GForce Promotions on Instagram', Icon: InstagramIcon },
    SOCIAL.linkedinUrl && { href: SOCIAL.linkedinUrl, label: 'GForce Promotions on LinkedIn', Icon: LinkedInIcon },
  ].filter(Boolean);

  if (!links.length) return null;
  return (
    <ul className={className} aria-label="Social">
      {links.map(({ href, label, Icon }) => (
        <li key={href}>
          <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label}>
            <Icon />
          </a>
        </li>
      ))}
    </ul>
  );
};

export default SocialIcons;
